import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const MetadataUser = t.type(
  {
    name: t.string,
    email: t.string,
    avatar_url: nullable(t.string),
  },
  'MetadataUser',
);

type MetadataUser = t.TypeOf<typeof MetadataUser>;
export { MetadataUser };
